import Func from "../func";
import dayjs, { Dayjs } from "dayjs";

export interface BillRaw {
  invoiceId: number | null | undefined;
  payeeCode: string | null | undefined;
  payeeName: string | null | undefined;
  bcustCode: string | null | undefined;
  carStateNum: string | null | undefined;
  qrCode: string | null | undefined;
  amt: number | null | undefined;
  payAmt: number | null | undefined;
  vatAmt: number | null | undefined;
  cur: string | null | undefined;
  receiveDate: string | null | undefined;
  startDate: string | null | undefined;
  endDate: string | null | undefined;
  status: string | null | undefined;
  statusName: string | null | undefined;
  parkingName: string | null | undefined;
  inDatetime: string | null | undefined;
  outDatetime: string | null | undefined;
  stayMinutes: number | null | undefined;
  invoiceType: string | null | undefined;
  active: boolean | null | undefined;
}

export class Bill {
  invoiceId: number;
  payeeCode: string | null | undefined;
  payeeName: string | null | undefined;
  bcustCode: string | null | undefined;
  carStateNum: string | null | undefined;
  qrCode: string | null | undefined;
  amt: number | null | undefined;
  payAmt: number | null | undefined;
  vatAmt: number | null | undefined;
  cur: string | null | undefined;
  receiveDate: Dayjs | null | undefined;
  startDate: Dayjs | null | undefined;
  endDate: Dayjs | null | undefined;
  status: string | null | undefined;
  statusName: string | null | undefined;
  parkingName: string | null | undefined;
  inDatetime: Dayjs | null | undefined;
  outDatetime: Dayjs | null | undefined;
  stayMinutes: number | null | undefined;
  invoiceType: string | null | undefined;
  active: boolean;

  constructor(data: BillRaw) {
    this.invoiceId = data.invoiceId ?? 0;
    this.payeeCode = data.payeeCode;
    this.payeeName = data.payeeName;
    this.bcustCode = data.bcustCode;
    this.carStateNum = data.carStateNum;
    this.qrCode = data.qrCode;
    this.amt = data.amt;
    this.payAmt = data.payAmt;
    this.vatAmt = data.vatAmt;
    this.cur = data.cur;
    this.receiveDate = Func.isNotNil(data.receiveDate) ? dayjs(data.receiveDate) : null;
    this.startDate = Func.isNotNil(data.startDate) ? dayjs(data.startDate) : null;
    this.endDate = Func.isNotNil(data.endDate) ? dayjs(data.endDate) : null;
    this.status = data.status;
    this.statusName = data.statusName;
    this.parkingName = data.parkingName;
    this.inDatetime = Func.isNotNil(data.inDatetime) ? dayjs(data.inDatetime) : null;
    this.outDatetime = Func.isNotNil(data.outDatetime) ? dayjs(data.outDatetime) : null;
    this.stayMinutes = data.stayMinutes;
    this.invoiceType = data.invoiceType;
    this.active = data.active ?? false;
  }

  // Helper method to create from JSON
  static fromJson(json: BillRaw): Bill {
    return new Bill(json);
  }
}
